module.exports = __webpack_public_path__ + "assets/login-frontend/id_blurry-4adc61a6b2a456b0.png";